$(document).ready(function () {
    $("#secondary-nav-mobile-opener").on("click", function (e) {
        e.preventDefault();
        $(".menu-wrapper").slideToggle();
        $(this).find("i").toggleClass("fa-angle-down");
        $(this).find("i").toggleClass("fa-angle-up");
        $("body").toggleClass("menu-open");
    });

    $("a[data-secondary-nav-menu]").on("click", function (e) {
        e.preventDefault();
        var targetId = $(this).attr("data-secondary-nav-menu");
        $(targetId).slideToggle();
        $(this).find(".fa-stack-1x").toggleClass("fa-plus");
        $(this).find(".fa-stack-1x").toggleClass("fa-minus");
    });

    $(window).scroll(function () {
        var top = $(window).scrollTop();
        var position = 57 - top;
        if (position < 0) {
            position = 0;
        }
        $(".component-secondary-navigation .mobile-opener").css("top", position + "px");
    });

    var menus = $(".component-secondary-navigation");
    if (menus.length) {
        $(".component-header ").addClass("no-shadow");
    }
});